export function percentageMinor(base, percent) {
  const points = Math.round(Number(percent) * 100);
  if (!Number.isSafeInteger(base) || base < 0 || !Number.isSafeInteger(points)) throw new Error("Geçersiz tutar veya oran");
  const value = BigInt(base) * BigInt(Math.abs(points));
  const rounded = Number((value + 5000n) / 10000n);
  return points < 0 ? -rounded : rounded;
}
export function presetPriceMinor(base, percent) {
  return base + percentageMinor(base, percent);
}
